// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3mjFg","signatureButtonsRight":"ModalSign_signatureButtonsRight__3_ind"};